import React from 'react'
import "./loading.scss";

const Loading = () => {
  return (
    <div className="loading_wrp">
      <img src={require("../../img/loading.gif")} alt="" />
    </div>
  );
}

export default Loading
